import { GregorianDatePicker } from "@/components/ui/gregorian-date-picker";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface GregorianDateTimePickerProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  disabled?: boolean;
  testId?: string;
}

function splitValue(v: string): { date: string; time: string } {
  if (!v) return { date: "", time: "" };
  const [d, tFull] = v.split("T");
  const t = (tFull || "").slice(0, 5);
  return { date: d || "", time: t };
}

function combine(date: string, time: string): string {
  if (!date) return "";
  return `${date}T${time || "00:00"}`;
}

export function GregorianDateTimePicker({
  value,
  onChange,
  className,
  disabled,
  testId,
}: GregorianDateTimePickerProps) {
  const { date, time } = splitValue(value);
  return (
    <div className={cn("flex gap-2", className)}>
      <GregorianDatePicker
        value={date}
        onChange={(d) => onChange(d ? combine(d, time) : "")}
        disabled={disabled}
        className="flex-1"
        testId={testId}
      />
      <Input
        type="time"
        lang="en-GB"
        value={time}
        onChange={(e) => onChange(combine(date, e.target.value))}
        disabled={disabled || !date}
        className="w-[110px]"
      />
    </div>
  );
}
